<template>
  <div class="skin-card-container">
    <div class="skin-card relative overflow-hidden">
      <img
        :src="skinPage.image_url"
        class="absolute w-full h-full"
        :alt="skinPage.skin_name"
      />
      <div class="skin-card__overview">
        <div class="flex flex-col text-center bg-metallic-grey-60 p-2 pt-5 relative">
          <div
            class="absolute self-center top-0 -mt-3 w-2/3 text-xs leading-sm rounded capitalize"
            :style="{ backgroundColor: rarityColor }"
          >
            {{ skinPage.rarity }}
          </div>
          <div
            class="text-center font-bold text-absolute-white"
            v-html="skinPage._highlightResult.skin_name.value"
          ></div>
          <div class="text-xs flex items-center justify-center">
            <img src="/images/misc/riot-point-icon.png" alt="riot point icon" class="mr-1" />
            <span>{{ formattedPrice }}</span>
          </div>
          <div class="bg-almost-black text-slightly-off-white text-xs leading-none">
            Released {{ skinPage.released_at }}
          </div>
        </div>
      </div>
      <div class="skin-card__details bg-metallic-grey-60 relative">
        <div class="absolute inset-x-0 top-0 text-xs text-slightly-off-white text-center">
          {{ skinPage.skin_name }}
        </div>
        <a :href="skinPage.url" class="simple-btn btn-white btn-ghost text-sm font-bold">View</a>
        <a :href="skinPage.buy_skin_url" class="simple-btn btn-gold text-sm font-bold mt-4">Buy Skin</a>
        <div class="absolute inset-x-0 bottom-0 text-xs text-slightly-off-white flex justify-between px-2">
          <div>{{ formattedPrice }}</div>
          <div>Released {{ skinPage.released_at }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    skinPage: Object,
  },

  computed: {
    formattedPrice() {
      if (!this.skinPage.price) {
        return 'N/A';
      }

      return this.skinPage.price + ' RP';
    },

    rarityColor() {
      switch (this.skinPage.rarity) {
        case 'common':
          return '#f7b733'; // smurfs-gold
        case 'semi-rare':
          return '#cd6133';
        default:
          return '#55486a'; // royal-purple
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.skin-card img {
  object-fit: cover;
  object-position: 75% 0;
}
</style>
